import React from 'react';
import { Box } from '@mui/material';

// URACE logo tile cropped from /Urace.png, as in the mockup.
export const BrandMark = ({ size = 32 }: { size?: number }) => (
  <Box
    component="span"
    role="img"
    aria-label="URACE"
    sx={{
      flex: 'none',
      width: size,
      height: size,
      borderRadius: `${Math.round(size / 4)}px`,
      border: '1px solid var(--border)',
      background: '#fff url(/Urace.png) 52% 37% / 190% no-repeat',
    }}
  />
);
